import React from "react";
import {Controller, SubmitHandler, useForm} from "react-hook-form";
import MWCaption from "../../components/MWCaption";

import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextareaAutosize,
  styled,
} from "@mui/material";

import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import * as MaintenanceApi from "../../api/workOrderApi/MaintenanceApi";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import SubTitle from "../../components/SubTitle";
import {useUpdateMutation} from "../../hooks/useQueryHooks";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {FormSection} from "../../styledComponents/StyledCreateForm";

import DeveloperBoardIcon from "@mui/icons-material/DeveloperBoard";
import {useQueryClient} from "react-query";
import {useLocation, useNavigate} from "react-router-dom";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";
import {EQWorkOrder, initializeWorkOrder} from "../../models/serverModels/workOrder/EQWorkOrder";

const ManageTableContainer = styled(Grid)(({theme}) => ({
  marginTop: "32px",
  flexFlow: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#fff",
}));

export const ManageTable = styled(TableContainer)(({theme}) => ({
  width: "50%",
  marginTop: "48px",
  marginBottom: "32px",
  paddingLeft: "16px",
  paddingTop: "32px",
  paddingRight: "16px",
  paddingBottom: "32px",
  backgroundColor: "#fff",
  boxShadow: `rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem`,

  "& .subTitle": {
    fontSize: "18px",
    fontWeight: 600,
  },
  "& table th, td": {
    border: `1px solid ${theme.palette.warning.main}`,
    [theme.breakpoints.down("sm")]: {
      padding: "8px",
    },
  },
  "& tbody th": {
    padding: "8px",
    color: theme.palette.warning.dark,
    fontWeight: 700,
    backgroundColor: theme.palette.warning.light,
  },
  "& textarea": {
    lineHeight: 1.5,
  },

  [theme.breakpoints.down("lg")]: {
    width: "80%",
    padding: "8px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    padding: 0,
  },
}));

const WorkOrderProcess = () => {
  const tokenState = useRecoilValue(tokenSelector);
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const {state} = useLocation();

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<EQWorkOrder>,
    Params.Update<EQWorkOrder>
  >({
    api: MaintenanceApi.processWorkOrder,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");

        navigate(-1);
        queryClient.invalidateQueries("MaintenanceList");
      },
    },
  });

  const {control, handleSubmit} = useForm<EQWorkOrder>({defaultValues: initializeWorkOrder});

  const onSubmit: SubmitHandler<EQWorkOrder> = (data) => {
    updateMutate({
      token: tokenState,
      item: {...initializeWorkOrder, ...data, uid: state.uid},
    });
  };
  return (
    <React.Fragment>
      <SubTitle subTitle="설비 점검 진행" />
      {isUpdateLoading && <MWProgress />}
      <FormSection>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ManageTableContainer container rowSpacing={4}>
            <MWCaption title="설비 점검 진행" color="#01579B" icon={<DeveloperBoardIcon />} />
            <ManageTable>
              <Box sx={{margin: "auto", width: "100%"}}>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell component="th" rowSpan={2}>
                        협력 업체명
                      </TableCell>
                      <TableCell>
                        <Controller
                          name="repairCompany"
                          control={control}
                          render={({field}) => (
                            <TextareaAutosize
                              defaultValue={field.value}
                              aria-label="minimum height"
                              onChange={field.onChange}
                              style={{width: "100%", padding: "8px", resize: "none"}}
                            />
                          )}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <Controller
                          name="isOutsourcing"
                          control={control}
                          render={({field}) => (
                            <FormControl>
                              <RadioGroup
                                name="isOutsourcing"
                                defaultValue={true}
                                onChange={field.onChange}
                                row
                              >
                                <FormControlLabel value={true} control={<Radio />} label="외부" />
                                <FormControlLabel value={false} control={<Radio />} label="자체" />
                              </RadioGroup>
                            </FormControl>
                          )}
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
            </ManageTable>
          </ManageTableContainer>
          <ConfirmButtonGroup
            link={`/WorkOrder/List/Received`}
            cancelText="취소"
            confirmText="진행"
          />
        </form>
      </FormSection>
    </React.Fragment>
  );
};

export default WorkOrderProcess;
